export const gear = [
    {
        name:"Slayer Shot",
        longDesc:"Works with any ranged weapon. If this ammunition is used in a successful ranged attack against a living target, it deals an additional 50 points of damage, the target can make a fortitude save (DC=15+bab) to reduce the damage by half. This bonus damage is not multiplied on a critical hit, however the target does not receive save to reduce it.",
        rarity:"epic",
        stack:1,
        type:"ammunition"
    },
    {
        name:"Explosive Arrows",
        longDesc:"Works with bows and crossbows. If this ammunition is used in a successful ranged attack, it deals additional damage as if it were a splash weapon, dealing half the damage to all creatures adjacent to the target square of the attack (reflex negates, DC=10+BAB).",
        rarity:"epic",
        stack:3,
        type:"ammunition"
    },
    {
        name:"Penetrating Shot",
        longDesc:"Works with any ranged weapon. If this ammunition is used in a successful ranged attack, A creature struck by a piece of penetrating ammunition must succeed at a DC 20+bab Fortitude save or the ammunition proceeds to travel into another creature in line. The attacker must be able to trace a line starting at her space and passing through both targets to make this additional attack. The second attack is made at a –4 penalty, in addition to any modifiers for added range.",
        rarity:"rare",
        stack:3,
        type:"ammunition"
    },    
    {
        name:"Masterwork Bullet",
        longDesc:"Works with guns. The ranged increment of the next ranged attack you make is increased by 30 feet.",
        rarity:"common",
        stack:3,
        type:"ammunition"
    },
    {
        name:"Brilliant Arrow",
        longDesc:"Works with bows and crossbows. Your next ranged attack with the weapon hits touch armor class instead of regular armor class if it is within half the weapons maximum range.",
        rarity:"epic",
        stack:3,
        type:"ammunition"
    },
    {
        name:"Flare Shot",
        longDesc:"Works with any ranged weapon. Your next ranged attack deals 2d6 fire damage instead of whatever damage it would normally deal. Additional upon reaching its desired distance, striking a target, or reaching your weapons maximum range (whichever comes first) the flare explodes, all illusions, including creatures with illusion spells active on them, and all darkness spells within 150 feet that don't have complete cover against this burst are supressed for 1 full round. This supressed time counts for the spells duration.",
        rarity:"common",
        stack:3,
        type:"ammunition"
    },
    {
        name:".45 ACP",
        longDesc:"Works with guns. Your next ranged attack with the weapon deals +1 damage for each 25 gold you are carrying. This damage is doubled if the creature is a humanoid type and carrying less gold than you (in their default stat sheet). A killing shot against an enemy with this bullet rewards a small gold pile.",
        rarity:"rare",
        stack:3,
        type:"ammunition"
    },
    {
        name:"Golden Bullet",
        longDesc:"Works with guns. If this ammunition is used in a successful ranged attack, it automatically counts as a critical threat, but must be confirmed as normal. Abilities that activate on critical hits still requires a roll within normal critical threat range.",
        rarity:"epic",
        stack:1,
        type:"ammunition"
    },
    {
        name:"Ammo Cartridge",
        longDesc:"Works with guns. If used while reloading it reduces the action required to reload by 1 step",
        rarity:"common",
        stack:20,
        type:"ammunition"
    },
    {
        name:"Burrowing",
        longDesc:"Works with all ranged weapons. This ammunition deals normal damage, but when it hits a living creature, it burrows into the creature's flesh, causing wracking pain until removed or until the bullet burrows its way out of the creature. While these bullets burrow, the creature is staggered. This effect lasts for 1d3 rounds or until the bullet is removed with a DC 15+BAB heal check made as a standard action, or until the creature heals more than the damage of the attack.",
        rarity:"rare",
        stack:1,
        type:"ammunition"
    },
    {
        name:"Blinding",
        longDesc:"Works with all ranged weapons. This ammunition deals normal damage, but when it strikes a creature it must make a dc=15+BAB fortitude save or it becomes blind for 1 round.",
        rarity:"common",
        stack:2,
        type:"ammunition"
    },   
    {
        name:"Canister Arrow",
        longDesc:"Can be drawn and combined while drawing a grenade typed gear item. Works with bows and crossbows. It can be combined with any grenade typed gear (or an alchemy bomb), and then if used in a successful ranged attack the ranged attack also applies the effects of the grenade used.",
        rarity:"common",
        stack:3,
        type:"ammunition"
    },
    {
        name:"Baja Blast",
        longDesc:"This can be thrown as a ranged grenade weapon with a range increment of 10 feet, on direct hit it deals 10d6 damage to the target, and all creatures within 20 feet of the blast (including any creature hit by a direct hit) take 10d6 damage, but can make a reflex save dc 15+bab to reduce it by half.",
        rarity:"epic",
        stack:1,
        type:"grenade"
    },
    {
        name:"Elemental Accelerant",
        longDesc:"This can be thrown as a ranged weapon with a range increment of 10 feet. When you throw this grenade, you choose one elemental type (fire, cold, electricity, acid) and on direct hit, the creature becomes vulnerable to that type of damage for 1 round. A fortitude save (dc 15+bab) causes the vulnerability to apply only to the next time it takes that kind of elemental damage. This damage increase stacks if the creature was already vulnerable to that element (max 100% increase).",
        rarity:"rare",
        stack:2,
        type:"grenade"
    },
    {
        name:"Potion Canister",
        longDesc:"Can be drawn and combined while drawing any curative potion, and then be throw as a ranged grenade weapon with a range increment of 10 feet. On a direct hit it applies the effect of the potion to the target, and all targets within 5 feet receive half of the effect, but can make a reflex save 10+bab to avoid it completely.",
        rarity:"common",
        stack:1,
        type:"grenade"
    },
    {
        name:"Grounding Bomb",
        longDesc:"Can be thrown as a ranged grenade weapon with a range increment of 50 feet. If this strikes a target that is currently flying, the target must make a reflex save dc 20+bab or it is instantly grounded, falling up to 600 feet, landing, and is unable to take off for 5 rounds. If the creature does not have a land speed it instead cannot fly further than 1 foot off the ground for the duration. While falling the creature can move 30 feet in any direction it chooses.",
        rarity:"common",
        stack:3,
        type:"grenade"
    },
    {
        name:"Alchemist's Fire",
        longDesc:"Splash weapon with a range increment of 10 feet. A direct hit deals 4d6 points of fire damage, and creatures adjacent to the square receive 2d6 fire damage (reflex halves, DC = 10+BAB). A direct hit also causes the target to catch fire (reflex negates, DC = 10+BAB, but 15 at the start of each of their turns).",
        rarity:"common",
        stack:3,
        type:"grenade"
    },
    {
        name:"Alchemist's Acid",
        longDesc:"Splash weapon with a range increment of 10 feet. A direct hit deals 4d6 points of acid damage, and creatures adjacent to the square receive 2d6 acid damage, reflex halves. A direct hit also coats the target in acid for 1 round, causing them to take an additional 2d6 acid damage at the start of their turn (reflex negates). Reflex DC = 10+BAB.",
        rarity:"common",
        stack:3,
        type:"grenade"
    },
    {
        name:"Liquid Nitrogen",
        longDesc:"Splash weapon with a range increment of 10 feet. A direct hit deals 4d6 points of cold damage, and creatures adjacent to the square receive 2d6 cold damage (reflex halves). A direct hit also coats the target in ice for 1 round, entangling them for 1 round (reflex negates). Reflex DC = 10+BAB.",
        rarity:"common",
        stack:3,
        type:"grenade"
    },
    {
        name:"Unstable Battery",
        longDesc:"Thrown weapon with a range increment of 5 feet. A direct hit deals 1d4 points of blugeoning damage (20x2). This second part counts as a splash weapon, and does not benefit from bonuses to thrown weapons (only splash weapons). A direct hit also deals 2d6 electricity damage to the target, and creatures adjacent to the square it lands on receive 3d6 electricity damage (reflex halves, DC = 10+BAB). A critical hit with a direct hit also causes the target to be stunned for 1 round (fort negates, 10+BAB+strength modifier). If thrown into water, the splash radius increases to 20 feet and deals double electricity damage (and its funny).",
        rarity:"rare",
        stack:3,
        type:"grenade"
    },
    {
        name:"Glitter Bomb",
        longDesc:"Range increment of 50 feet. On reaching its desired destination it explodes and all creatures within 10 feet of the bomb are instantly covered in glitter for 5 rounds, any creature that is invisible becomes clearly outlined, and gains a -40 to stealth checks.",
        rarity:"common",
        stack:3,
        type:"grenade"
    },
    {
        name:"Net Bomb",
        longDesc:"Range increment of 10 feet. On landing in a square or colliding with a creature, all creatures within 5 feet of the bomb must make a reflex save DC 20+BAB or are rooted in place making them unable to move in any way, even teleportation for 1 round. If the creature is flying with wings it also falls to the ground, taking fall damage as normal.",
        rarity:"common",
        stack:3,
        type:"grenade"
    },
    {
        name:"EMP Grenade",
        longDesc:"Range increment of 10 feet. On landing in a square or colliding with a creature, it emits a pulse in as if using a area dispel with greater dispel magic, at caster level 5 + level. Creatures with spell casting ability within range must make a will save dc 15+bab or be unable to cast any spells for 1 round. Constructs struck also take 10d6 damage, fortitude save for half (dc = 10+BAB).",
        rarity:"rare",
        stack:2,
        type:"grenade"
    },
    {
        name:"Silver Blanch",
        longDesc:"The next 10 attacks from the weapon count as a silver weapon, and it deals an additional 2d6 damage against creatues with DR silver.",
        rarity:"common",
        stack:3,
        type:"blanch"
    },
    {
        name:"Cold Iron Blanch",
        longDesc:"The next 10 attacks from the weapon count as a cold iron weapon, and it deals an additional 2d6 damage against creatues with DR cold iron.",
        rarity:"common",
        stack:3,
        type:"blanch"
    },
    {
        name:"Tungsten Blanch",
        longDesc:"The next 10 attacks from the weapon have a -4 penalty to their attack rolls, but have their damage increased by 2 dice steps.",
        rarity:"rare",
        stack:2,
        type:"blanch"
    },
    {
        name:"Swarmbane Blanch",
        longDesc:"The next 10 attacks from the weapon deal full damage to swarms regardless of the swarm's immunity to weapon damage, although DR still applies.",
        rarity:"common",
        stack:2,
        type:"blanch"
    },
    {
        name:"Ghost Salt Blanch",
        longDesc:"The next 10 attacks from the weapon count as a ghost touch weapon, and it deals an additional 2d6 damage against incorporeal undead.",
        rarity:"common",
        stack:3,
        type:"blanch"
    },
    {
        name:"Adamantine Powder",
        longDesc:"The next 10 attacks from the weapon count as a adamantine weapon, and it deals an additional 2d6 damage against constructs and objects.",
        rarity:"rare",
        stack:3,
        type:"blanch"
    },
    {
        name:"Magic Blanch",
        longDesc:"This blanche gives the weapon a +1 enhancement bonus for 10 attacks. This also causes it to bypass magic damage reduction.",
        rarity:"common",
        stack:3,
        type:"blanch"
    },
    {
        name:"Powerful Magic Blanch",
        longDesc:"This blanche gives the weapon a +3 enhancement bonus for 10 attacks. This also causes it to bypass magic, cold iron, and silver damage reduction.",
        rarity:"rare",
        stack:3,
        type:"blanch"
    },
    {
        name:"Whetstone",
        longDesc:"This blanche doubles the weapon's critical threat range for 10 attacks. If the weapon already has a critical threat range being doubled by another ability, it gains a flat +1 to critical threat range (which is not multiplied).",
        rarity:"rare",
        stack:2,
        type:"blanch"
    },
    {
        name:"Legendary Blanch",
        longDesc:"This blanche gives the weapon a +5 enhancement bonus for 10 attacks, this also causes it to bypass magic, cold iron, silver, adamantine, and alignment DR.",
        rarity:"epic",
        stack:1,
        type:"blanch"
    },
    {
        name:"Blessed Blanch",
        longDesc:"The next 10 attacks from the weapon count as a good weapon for bypassing DR and deals an additional 2d6 sacred damage.",
        rarity:"rare",
        stack:2,
        type:"blanch"
    },
    {
        name:"Cursed Blanch",
        longDesc:"The next 10 attacks from the weapon count as a evil weapon for bypassing DR and deals an additional 2d6 profane damage.",
        rarity:"rare",
        stack:2,
        type:"blanch"
    },
    {
        name:"Poison Vial",
        longDesc:`The next attack with the weapon/ammunition also possibly poisons the target. The poison's DC is determined by a (craft/survival check - 10) that you roll when the poison hits the target. The poison deals ability score damage that is determined by a 1d4 roll \n1: strength \n2: dexterity \n3: constitution \n4: strength and dexterity.
        \nPoison: injury; fort; frequency 1/round for 6 rounds; deal 1d4 ability damage; cure 1 saves.`,
        rarity:"rare",
        stack:3,
        type:"blanch"
    },
    {
        name:"Ice Blanch",
        longDesc:"The next 10 attacks from the weapon deal an additional 2d6 cold damage.",
        rarity:"common",
        stack:3,
        type:"blanch"
    },
    {
        name:"Acid Blanch",
        longDesc:"The next 10 attacks from the weapon deal an additional 2d6 acid damage.",
        rarity:"common",
        stack:3,
        type:"blanch"
    },
    {
        name:"Shock Blanch",
        longDesc:"The next 10 attacks from the weapon deal an additional 2d6 electricity damage.",
        rarity:"common",
        stack:3,
        type:"blanch"
    },
    {
        name:"Voltage",
        longDesc:"The next attack from the weapon deals an additional 10d6 electricity damage and the critical threat range is increased by a flat +2. The electricity damage is multiplied by critical hits.",
        rarity:"epic",
        stack:1,
        type:"blanch"
    },
    {
        name:"Magic Rope",
        longDesc: `This 100 ft rope can be used for anything a regular rope could be, however it also has various other uses: 
        \nAs a standard action you can place it on any ledge, allowing any creature climbing that ledge a +8 to their check, this lasts until the rope is destroyed.
        \nAs a standard action you can cause the rope to trip and entangle an opponent, the target must make a reflex save DC 20+bab or become entangled and prone. It can remove the entangled condition by dealing 10 damage to the rope.
        \nOnce the rope is used for any of these purposes, it falls apart afterwards.`,
        rarity:"common",
        stack:2,
        type:"utility"
    },
    {
        name:"Gravity Gun",
        longDesc:"As a standard action you can pull any piece of treasure within 50 feet of you, that you can both see and have line of effect to. This pulls it to any square adjacent to you.",
        rarity:"common",
        stack:1,
        type:"utility"
    },    
    {
        name:"Treasure Compass",
        longDesc:"When you use this you can specify one type of treasure, and learn the closest ones approximate direction and distance from you. If the item requires a check to obtain you gain a +4 bonus on any skill roll associated with it. If you specify a treasure type not on the map this item is wasted with no effect.",
        rarity:"common",
        stack:2,
        type:"utility"
    },
    {
        name:"Winged Shoes",
        longDesc:"Once activated as a standard action you gain a 30 foot fly speed (good) for 6 rounds.",
        rarity:"common",
        stack:2,
        type:"utility"
    },
    {
        name:"Emergency Injector",
        longDesc:"You can combine this with any type of potion and draw a potion while drawing this. It can be equipped as a standard action, you can equip multiple injectors at the same time. Once equipped you can activate it at any time, you dont even need to be conscious or able to take actions, once you do you are effected by the potion as if you had drunk it. You can apply an emergency injector to an adjacent willing ally as a full round action.",
        rarity:"rare",
        stack:1,
        type:"utility"
    },
    {
        name:"Lucky Charm",
        longDesc:"You can use up this item with no additional action cost, and it doesn't need to be drawn before hand, though you must decalre its use before you roll. When making a check to obtain treasure, you can expend the lucky charm to allow you to roll twice and take the higher result.",
        rarity:"common",
        stack:3,
        type:"utility"
    },
    {
        name:"Amelia's Favorite Snack",
        longDesc:"You can use this when about to enter a store. It has 2 possible uses, first, you can expend it to allow you to reroll the store's type. Alternatively, you can give it to Amelia to increase the store's discount by 5%, and increase the amount of any single item by 1 (after any other modifiers).",
        rarity:"legendary",
        stack:1,
        type:"utility"
    },
    {
        name:"Akashic Recombobulator",
        longDesc:"You can use this reroll an encounter. You can only do this once per floor, and can only be done when about the enter the floor of the next encounter (but before you have selected your next encounter).",
        rarity:"legendary",
        stack:1,
        type:"utility"
    },
    {
        name:"Livewire",
        longDesc:"This item is retrieved and drank like a potion, once drank it lasts 8 rounds and grants a +6 alchemical bonus to all physical ability scores, a +2 alchemical bonus to all saves, and during its effect you are cured of and immune to sleep effects, fatigue, exhaustion, and fascination. After the 8 rounds you become exhausted and take 1 point of constitution damage.",
        rarity:"epic",
        stack:1,
        type:"utility"
    },
    {
        name:"Chug Jug",
        longDesc:"This item is retrieved and drank like a potion. Once you drink it, it grants temporary hit points equal to half your maximum hit points. These last 10 rounds.",
        rarity:"epic",
        stack:1,
        type:"utility"
    },
    {
        name:"Masterwork Anytool",
        longDesc:"You can use up this item with no additional action cost while making any non-knowledge skill check, gaining +4 circumstance bonus to that skill roll. You must choose to use this before you roll.",
        rarity:"common",
        stack:5,
        type:"utility"
    },
    {
        name:"Bomb Sling",
        longDesc:"You can draw this while drawing any bomb gear or alchemy bomb, and used while throwing it. Double the range increment of the thrown bomb and gain a +4 to attack. Any bomb used with the bomb sling has its DC increased by +4.",
        rarity:"common",
        stack:3,
        type:"utility"
    },
    {
        name:"Monster Manual",
        longDesc:"You can use up this item with no additional action cost and doesn't need to be drawn before hand, while making a knowledge skill check to identify a monster you gain +4 circumstance bonus to that skill roll. If you are holding the monster manual while making the check you instead gain a +8 circumstance bonus. You must choose to use this before you roll.",
        rarity:"common",
        stack:3,
        type:"utility"
    },
    {
        name:"Masterwork Tool",
        longDesc:"You can use up this item with no additional action cost and doesn't need to be drawn before hand, while making a skill check with the skill listed, gain a +4 circumstance bonus. If you are holding the tool when making the check you instead gain a +8 circumstance bonus. You must choose to use this before you roll.",
        rarity:"common",
        stack:3,
        type:"utility"
    },
    {
        name:"Special Eye Contacts",
        longDesc:"Can be equipped as a standard action to help see through difficult visibility conditions such as darkness (even magical darkness), lowlight, fog, smoke, or anything else, allowing you to see an extra 30 feet in any condition for 5 minutes, this bonus does not stack with like bonuses, such as actual dark vision. You can also choose to reduce the duration of the contact lenses by 1 minute as a free action to allow you to see through illusions such as displacement or invisibility for 1 round, you can't do this two rounds in a row.",
        rarity:"common",
        stack:2,
        type:"utility"
    },
    {
        name:"Glow Stick",
        longDesc:"Can be activated as a standard action to shed light for 1 minute. This light brightens the light within 30 feet of you to normal light, but casts no light further, even dim light. Even in places of magical darkness the lighting level within 30 feet is automatically set to normal light, however it doesn't counter and end any darkness spells, nor can it be countered and ended by any darkness spells.",
        rarity:"common",
        stack:2,
        type:"utility"
    },
    {
        name:"Helpful Hand",
        longDesc:"While drawing another item or potion from your bag you can expend one use of this even if you aren't currently holding it to change the action to withdraw an item from the bag to a swift action and it no longer provokes an attack of opportunity.",
        rarity:"common",
        stack:2,
        type:"utility"
    },
    {
        name:"Code Red",
        longDesc:"This is drunk as a movement action. Gain a standard action, a movement action, and a swift action this round. In 1 round, you are staggered for 1 round and suffer 1 permanent negative level.",
        rarity:"epic",
        stack:1,
        type:"utility"
    },
    {
        name:"Suspicious Potion",
        longDesc:"Can be drawn and drank just like a normal potion. When imbibed you gain the effects of a totally random potion unrestricted by level.",
        rarity:"rare",
        stack:2,
        type:"utility"
    },
    {
        name:"20-Sided Clover",
        longDesc:"This item can be used without being drawn from your bag before hand. You can use this directly after any sort of RNG happens, including dice rolls, random effects, and even treasure drops, reroll it. You must take the second result even if worse.",
        rarity:"epic",
        stack:1,
        type:"utility"
    },
    {
        name:"Grenade Tape",
        longDesc:"You can draw this item at the same time as drawing 2 other grenades. As a movement action you can tape two grenades you are holding together. The range increment of this combined grenade uses the lower of the two range increments and suffers an additional -4 to attack. You can tape more than 2 grenades together if you have additional tape, the attack penalty stacks. You can also just use this as tape if thats helpful.",
        rarity:"common",
        stack:2,
        type:"utility"
    },
    {
        name:"Penetrating Focus",
        longDesc:"You can use this while casting a spell for no additional action, increase your roll to penetrate spell resistance by +4. You can only use 1 implement at a time",
        rarity:"common",
        stack:2,
        type:"implement"
    },
    {
        name:"Heightening Focus",
        longDesc:"You can use this while casting a spell for no additional action, increase your caster level by 3 for the effects of the spell, this does not apply to any other effects for the spell, such as concentration or spell resistance. You can only use 1 implement at a time",
        rarity:"common",
        stack:2,
        type:"implement"
    },
    {
        name:"Subjugating Focus",
        longDesc:"You can use this while casting a spell for no additional action, increase the DC of the spell by 2. You can only use 1 implement at a time",
        rarity:"rare",
        stack:2,
        type:"implement"
    },
    {
        name:"Focus Focus",
        longDesc:"You can use this while casting a spell for no additional action, you automatically succeed any concentration check you would have to make while casting this spell.",
        rarity:"common",
        stack:2,
        type:"implement"
    },
    {
        name:"Spell Storing Focus",
        longDesc:"You can use this while casting a spell for no additional action to cause the spell is stored inside of this focus. Then while holding it, you can as an immediate action break this focus to have the spell stored cast on you. It can also be traded to another player. The stored spell only affects the breaker of the focus even if it would normally affect others.",
        rarity:"common",
        stack:2,
        type:"implement"
    },
    {
        name:"Destructive Focus",
        longDesc:"You can use this while casting a spell for no additional action, the spell gains 25 spell power. You can only use 1 implement at a time",
        rarity:"rare",
        stack:2,
        type:"implement"
    },
    {
        name:"Mental Focus",
        longDesc:"You can use this while casting a spell for no additional action, the spell cost is reduced to 0 spell points (other modifiers to the spell cost may still apply). You can only use 1 implement at a time",
        rarity:"common",
        stack:3,
        type:"implement"
    },
    {
        name:"Metamagic Focus",
        longDesc:"You can use this while casting a spell for no additional action, you can cast a spell with a metamagic applied without requiring a higher level spell slot, or increasing the casting time.",
        rarity:"rare",
        stack:2,
        type:"implement"
    },
    {
        name:"Elemental Focus",
        longDesc:"You can use this while casting a spell for no additional action, If your spell deals a specific type of energy damage you can alter it to instead deal damage of a different elemental choice (fire, cold, acid, electricity). You can make this elemental choice while casting the spell.",
        rarity:"common",
        stack:2,
        type:"implement"
    },
    {
        name:"Implement Focus",
        longDesc:"You can use this while casting a spell for no additional action, while casting a spell with this focus you can choose to use any other focus you own, even if its not currently drawn without expending a use of that focus (this focus is still expended)",
        rarity:"common",
        stack:2,
        type:"implement"
    },
    {
        name:"Metamagic Implement",
        longDesc:`You can use this while casting a spell for no additional action, the spell is effected by the listed metamagic feat without increasing casting time or spell point cost. To use this rod on a spell the spell must still meet all prerequisites for that metamagic feat. You can only use 1 implement at a time`,
        rarity:"common",
        stack:2,
        type:"implement"
    },
    {
        name:"Voo-Dew",
        longDesc:`You can use this while casting a spell for no additional action. This can only be used with a spell that is cast as a full-round action or less. The spell is cast as a free action, though it costs twice the amount of spell points, and has a 10% increased spell critical failure chance. This allows you to bypass the normal 2 spells per round rule. After using this, you suffer constitution drain equal to 1/2 the spells level (rounded down).`,
        rarity:"epic",
        stack:1,
        type:"implement"
    },
]